import "./OurGraphic.scss";
import Card, {GalleryItem} from "../../../Components/CardGallery/CardGallery";
import {useState} from "react";
import {useTranslation} from "react-i18next";

interface GalleryProps {
    galleryData: GalleryItem[];
}

export default function OurGraphic({
                                       galleryData,
                                   }: GalleryProps) {
    const [galleryDataWiew, setGalleryDataWiew] = useState(11);
    const { t } = useTranslation();


    return (
        <>
            <div className="work-section__heading">
                <h2 className="work-section__title">
                    {t("works.graphic.title")}
                </h2>

                <div className="work-section__eyebrow">
                    <span />
                    {t("works.graphic.subtitle")}
                    <span />
                </div>
            </div>

            <div className="gallery__container">
                <div className="gallery">
                    {galleryData.slice(0, galleryDataWiew).map((item, index) => (
                        <Card
                            key={`${item.cliente}-${index}`}
                            item={item}
                        />
                    ))}
                    {(galleryDataWiew < galleryData.length) && (
                        <div onClick={() => {setGalleryDataWiew(galleryDataWiew + 10)}} className="card gallery-more-card">
                            <div className="gallery-more-card__content">
                                <p>{t("works.graphic.other")}</p>
                                <h1>+{galleryData.length > 10 ? galleryData.length - galleryDataWiew : 10}</h1>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}